// extracted by mini-css-extract-plugin
export default {"btn":"footer_fr_in_out_btn__s+WR5"};